import RequireAuth from '../Components/RequireAuth';
import { Routes, Route } from 'react-router-dom';
import ViewGalleries from './Gallery/Galleries';
import ViewGallery from './Gallery/ViewGallery';
import AddPictures from './Gallery/AddPictures';
import EditPicture from './Gallery/EditPicture';
import AddGallery from './Gallery/AddGallery';

function Gallery({img}) {
  return (
    <Routes>
      <Route exact path='/' element={<ViewGalleries img={img}/>} />
      <Route exact path='/view/:id' element={<ViewGallery img={img}/>} />
      <Route element={<RequireAuth allowedRoles={[3, 4, 5]} />}>
        <Route exact path='/add' element={<AddGallery img={img}/>} />
        <Route exact path='/addpics/:id' element={<AddPictures img={img}/>} />
        <Route exact path='/edit/:id' element={<EditPicture img={img}/>} />
      </Route>
    </Routes>
  )
}

export default Gallery